import { EVENTS_CONSTANTS } from "config/constants";

const { EVENT_PERIOD_IDS } = EVENTS_CONSTANTS;

const getInactivitySplittedByHours = inactivity => {
	return inactivity.reduce((acc, item) => {
		const { start, end } = item.time;
		const quantityHours = (end - start) / 60;
		return [
			...acc,
			...Array(quantityHours)
				.fill()
				.map((_, idx) => {
					const newStart = start + idx * 60;
					return {
						...item,
						time: {
							start: newStart,
							end: newStart + 60,
						},
					};
				}),
		];
	}, []);
};
export const getBodyToAddOrUpdateRequestStep1 = form => {
	const { adviser } = form.part1;
	const {
		periodId,
		duration: { onlyDay, manyDays },
	} = form.part2;
	let body = {
		idCodPsicologo: adviser.code,
	};
	if (periodId === EVENT_PERIOD_IDS.ONLY_DAY) {
		const { date, time } = onlyDay;
		const { inactivity } = time;
		body = {
			...body,
			diaUnico: {
				fecha: date,
				horario: {
					inicio: time.start,
					fin: time.end,
					inactividad: getInactivitySplittedByHours(inactivity).map(
						({ time: { start: inicio, end: fin } }) => {
							return {
								horario: { inicio, fin },
								fecha: date,
							};
						}
					),
				},
			},
		};
	} else if (periodId === EVENT_PERIOD_IDS.MANY_DAYS) {
		const { date, time } = manyDays;
		const fecha = {
			inicio: date.start,
			fin: date.end,
		};
		const horario = time.map(
			({ dayId: idDia, start: inicio, end: fin, inactivity }) => {
				return {
					idDia,
					inicio,
					fin,
					inactividad: getInactivitySplittedByHours(inactivity).map(
						({
							time: timeInactivityItem,
							date: dateInactivityItem,
						}) => {
							return {
								fecha: dateInactivityItem,
								horario: {
									inicio: timeInactivityItem.start,
									fin: timeInactivityItem.end,
								},
							};
						}
					),
				};
			}
		);
		body = {
			...body,
			variosDias: {
				fecha,
				horario,
			},
		};
	}
	return body;
};
export const getBodyToAddOrUpdateRequestStep2 = form => {
	const { locationId, place } = form.part1;
	const { publicByCampusIds, modalityId } = form.part2.publicLoad.students;
	let body = {
		idUbicacion: locationId,
		estudiantesGeneral: {
			campusIds: publicByCampusIds,
			idModalidad: modalityId,
		},
	};
	if (locationId === 2) {
		const {
			campus,
			environment: { envName, floor },
		} = place;
		body = {
			...body,
			idCampusDetalle: campus.id,
			ambienteDentroCampus: envName,
			piso: floor,
		};
	}
	return body;
};
export const appointmentsMapper = ({ asesor, asesorias }) => {
	return {
		adviser: asesor && {
			code: asesor.id,
			name: asesor.nombre,
		},
		appointments: asesorias.map(({ horario, inactividad, reservas }) => {
			let place = null;
			if (horario.lugar) {
				const {
					ambiente: environment,
					campus,
					direccion: address,
					piso: floor,
				} = horario.lugar;
				place = {
					environment,
					campus,
					address,
					floor,
				};
			}
			return {
				schedule: {
					appointmentId: horario.idAsesoria,
					appointmentDateId: horario.idAsesoriaFecha,
					date: horario.fecha,
					durationId: horario.idDuracion,
					start: horario.inicio,
					end: horario.fin,
					isPresential: horario.esPresencial,
					place,
				},
				reservations: reservas.map(
					({
						idReservaAsesoria: id,
						estudiante,
						horaInicio: timeStart,
						asistio: attended,
						celular: phone,
						comentario: comment,
						enlaceZoom: zoom,
						indiceReserva,
						totalReservas,
						esPresencial: isPresential
					}) => {
						return {
							id,
							student: {
								id: estudiante.id,
								name: estudiante.nombre,
							},
							timeStart,
							attended,
							zoom,
							isPresential,
							phone,
							comment,
							quantity: {
								idx: indiceReserva,
								total: totalReservas,
							},
						};
					}
				),
				inactivities: !inactividad
					? []
					: inactividad.map(
							({
								idAsesoriaInactividad: id,
								inicio: start,
								fin: end,
							}) => ({ id, start, end })
					  ),
			};
		}),
	};
};
